import { useState } from 'react'
import { Box, Typography, Skeleton, styled } from '@mui/material'
import { nothing } from '$func/utils'
import { PageWithAppBar } from '$common/page-with-app-bar'
import { AppBarBackTitleSearch } from '$common/app-bar/app-bar-back-title-search'
import { ActionButton, ACTION_BUTTON_CONSUMED_HEIGHT } from './action-button'
import { APP_BAR_HEIGHT } from '$common/app-bar/app-bar.constants'
import { useWindowHeight } from '$func/window.react-hook'
import { WithAppBarAndActionButtonProps } from './searchable-list-page.types'
import { useDebounce } from '$common/react-hooks/use-debounce'

const SUB_HEADER_TEXT_HEIGHT = 37

const SubHeaderContainer = styled(Box)`
  background-color: white;
  box-sizing: border-box;
  padding: 10px 20px 2px 0;
`

export function WithAppBarAndActionButton({
  appBarTitle,
  loading = false,
  actionButtonText = '',
  actionButtonIcon,
  hideActionButton = false,
  onActionButtonClick = nothing,
  subHeaderText = '',
  onBack,
  children,
  FAB,
  isFABVisible,
  useCustomScroller,
  changeQueryDebounceMS = 1000,
}: WithAppBarAndActionButtonProps) {
  const windowHeight = useWindowHeight()
  const [query, setQuery] = useState<string>()

  const { debouncedValue: debouncedQuery } = useDebounce(
    query,
    changeQueryDebounceMS,
  )

  const showActionButton =
    query || hideActionButton ? false : !!actionButtonText

  const showSubHeaderText = !query && !!subHeaderText

  const listHeight =
    windowHeight -
    APP_BAR_HEIGHT -
    (showActionButton ? ACTION_BUTTON_CONSUMED_HEIGHT : 0) -
    (subHeaderText ? SUB_HEADER_TEXT_HEIGHT : 0)

  return (
    <PageWithAppBar
      FAB={FAB}
      isFABVisible={isFABVisible}
      appBar={
        <AppBarBackTitleSearch
          title={appBarTitle}
          onBack={onBack}
          setQuery={setQuery}
        />
      }
      useCustomScroller={useCustomScroller}
    >
      {showActionButton && (
        <ActionButton
          text={actionButtonText}
          icon={actionButtonIcon}
          onClick={onActionButtonClick}
        />
      )}

      {showSubHeaderText && (
        <SubHeaderContainer>
          {loading ? (
            <Skeleton variant="text" width={120} />
          ) : (
            <Typography color="primary" variant="subtitle3">
              {subHeaderText}
            </Typography>
          )}
        </SubHeaderContainer>
      )}

      {children(listHeight, debouncedQuery || '')}
    </PageWithAppBar>
  )
}
